import { Component, Input, Output, EventEmitter } from "@angular/core";
import { CDN_BASE_URL } from 'src/constants/param-constants';
@Component({
    selector: "upsell-mbg",
    templateUrl: "upsell-mbg.html",
    styleUrls: ["upsell-mbg.scss"],
})

export class UpsellMBGComponent {
  @Input() mbgText: string = '';
  @Input() mbgDays: number = 60;
  @Input() mbgCTA: boolean = false;
  @Input() productName: string = '';
  @Input() buttonYesText: string = 'Yes I want this special added to my order';
  @Input() buttonNoText: string = 'No thanks, I understand that I won\'t see this offer again';
  @Output() eventEmitter: EventEmitter<boolean> = new EventEmitter();

  get displayMbgText(): string {
    return this.mbgText || 
    `
      <div class='text-3xl text-bhmd-blue'>Our Promise to You</div>
      <p>As doctors, we are dedicated to help you get the EXACT results you're looking for. We are confident that we have formulated the very best skincare products available — but if for any reason you are unsatisfied with your purchase, just return it within ${this.mbgDays} days for a full refund — guaranteed.</p>
      <p>If you have any questions or concerns about your order, simply call us at 877-828-5528, or email us at <a class="text-bhmd-blue" target="_blank" href="mailto:customersupport@beverlyhills-md.com">customersupport@beverlyhills-md.com</a> and our experienced customer support specialists will be happy to help!</p>
      <p class='mb-0'>Sincerely, Dr. John Layke and Dr. Payman Danielpour<br>Beverly Hills MD</p>
    `;
  }

  get mbgBadgeLink(): string {
    return `${CDN_BASE_URL}/images/BHMD-${this.mbgDays}Day-Badge.png`;
  }

  constructor() {}

  nextPage(buttonValue: boolean) {
    this.eventEmitter.emit(buttonValue);
  }
}
